<template>
    <file-manager-modal
            v-if="show"
            :size="size"
            :show="show"
            @file-manager-modal-close="close()">

        <div class="modal-header">
            <h4 class="modal-title">{{ t.__('Utwórz katalog') }}</h4>
            <button type="button" class="close" @click="close()"><span aria-hidden="true">&times;</span></button>
        </div>

        <div class="modal-body">
            <div class="form-group fg-line">
                <label>{{ t.__('Nazwa katalogu') }}</label>
                <input ref="folderName"
                       v-model="newFolderName"
                       type="text"
                       class="form-control"
                       :disabled="loading"
                       @keyup.enter="createFolder()">
            </div>
            <file-manager-errors :errors="errors"/>
        </div>

        <div class="modal-footer">
            <button class="btn btn-primary"
                    type="button"
                    :disabled="loading"
                    @click="createFolder()">
                <template v-if="loading">{{ t.__('Tworzę...') }}</template>
                <template v-if="!loading">{{ t.__('Utwórz') }}</template>
            </button>
            <button class="btn btn-light"
                    type="button"
                    :disabled="loading"
                    @click="close()">
                {{ t.__('Anuluj') }}
            </button>
        </div>

    </file-manager-modal>
</template>

<script>
    import axios from "axios";
    import fileManagerMixin from "./../../mixins/file-manager-mixin";
    import FileManagerErrors from "./FileManagerErrors";

    export default {
        components: {
            'file-manager-errors': FileManagerErrors,
        },

        mixins: [fileManagerMixin],

        props: {
            currentPath: {
                default: '',
                type: String
            },

            show: {
                default: false,
                type: Boolean
            }
        },

        data() {
            return {
                errors: [],
                loading: false,
                newFolderName: null,
                size: 'modal-sm'
            };
        },

        watch: {
            show: function (val) {
                if (val) {
                    window.Vue.nextTick(() => {
                        this.$refs.folderName.focus();
                    });
                }
            }
        },


        mounted() {
            document.addEventListener('keydown', (e) => {
                if (this.show && e.keyCode === 13) {
                    this.createFolder();
                }
            });
        },

        methods: {
            close() {
                this.newFolderName = null;
                this.loading = false;
                this.errors = [];
                this.$emit('file-manager-modal-close');
            },

            createFolder() {

                if (!this.newFolderName) {
                    this.errors = [t.__('Proszę podać nazwę katalogu')];
                    return;
                }

                const data = {
                    'current_path': this.currentPath,
                    'new_folder_name': this.newFolderName
                };

                this.loading = true;
                axios.post(route('file-manager.create-folder'), data).then(
                    (response) => {
                        this.fileManagerNotify(response.data.message, 'success');
                        this.$emit('reload-folder');
                        this.close();
                    },
                    (response) => {
                        this.errors = response.data.data.message;
                        this.loading = false;
                    }
                );
            }
        }
    };
</script>
